export { default } from './CocktailCard'
